<!-- src/app/transactions-table/transactions-table.component.html -->
<div class="mat-elevation-z8">
<div class="d-flex gap-3">
  <mat-card appearance="outlined" class="wallet-card flex-fill">
    <mat-card-header>
      <mat-card-title>Wallet Details</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <app-withdrawal></app-withdrawal>
    </mat-card-content>
  </mat-card>
  
  <mat-card appearance="outlined" class="wallet-card flex-fill">
    <mat-card-header>
      <mat-card-title>Wallet Details</mat-card-title>
    </mat-card-header>
    <mat-card-content>
    <app-wallet-summary></app-wallet-summary>
    </mat-card-content>
  </mat-card>
</div>

    <!-- Loading Spinner -->
    <div *ngIf="isLoading" class="spinner-container">
      <mat-spinner class="small-spinner"></mat-spinner>
    </div>
  
    <!-- Error Message -->
    <div *ngIf="!isLoading && errorMessage" class="error-message">
      {{ errorMessage }}
    </div>
  
    <!-- Content when not loading and no error -->
    <div *ngIf="!isLoading && !errorMessage">
  
      <!-- Toggle Button Group for Filtering -->
      <div class="filter-toggle d-flex justify-content-between">
        <h3>Transaction Details</h3>
        <mat-button-toggle-group [value]="selectedFilter" (change)="onFilterChange($event.value)" aria-label="Transaction Type Filter">
          <mat-button-toggle *ngFor="let option of filterOptions" [value]="option">
            {{ option }}
          </mat-button-toggle>
        </mat-button-toggle-group>
      </div>
  
      <table mat-table [dataSource]="dataSource" class="full-width-table">
  
        <!-- Date Column -->
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef> Date </th>
          <td mat-cell *matCellDef="let element"> {{element.date}} </td>
        </ng-container>
  
        <!-- Category Column -->
        <ng-container matColumnDef="category">
          <th mat-header-cell *matHeaderCellDef> Category </th>
          <td mat-cell *matCellDef="let element"> {{element.category}} </td>
        </ng-container>
  
        <!-- Amount Column -->
        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef> Amount </th>
          <td mat-cell *matCellDef="let element"> {{+element.amount | currency: 'GBP'}} </td>
        </ng-container>
  
        <!-- Type Column -->
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef> Type </th>
          <td mat-cell *matCellDef="let element"> {{element.type}} </td>
        </ng-container>
  
        <!-- Status Column -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef> Status </th>
          <td mat-cell *matCellDef="let element"> {{element.status || 'N/A'}} </td>
        </ng-container>
  
        <!-- Transaction ID Column -->
        <ng-container matColumnDef="transactionId">
          <th mat-header-cell *matHeaderCellDef> Transaction ID </th>
          <td mat-cell *matCellDef="let element"> {{element.transactionId || 'N/A'}} </td>
        </ng-container>
  
        <!-- Payment Type Column -->
        <ng-container matColumnDef="paymentType">
          <th mat-header-cell *matHeaderCellDef> Payment Type </th>
          <td mat-cell *matCellDef="let element"> {{element.paymentType || 'N/A'}} </td>
        </ng-container>
  
        <!-- Header and Row Declarations -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  
        <!-- No Data Row -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell no-data-row" [attr.colspan]="displayedColumns.length">
            No transactions found.
          </td>
        </tr>
  
      </table>
  
      <!-- Paginator -->
      <mat-paginator [pageSizeOptions]="[10]" showFirstLastButtons></mat-paginator>
  
    </div>
  
  </div>
  